import { Megaphone } from "lucide-react";
import { fmtDate, promoLabel } from "@/lib/money";

export function PromoBanner({ promotions, planId, compact }) {
  const now = Date.now();
  const list = (promotions || []).filter((p) => (!p.ends_at || new Date(p.ends_at).getTime() > now) && (!planId || !p.plan_ids?.length || p.plan_ids.includes(planId)));
  if (!list.length) return null;
  const p = list[0];
  return (
    <div className={`flex items-start gap-2 rounded-xl border border-amber-400/40 bg-amber-400/10 text-amber-100 ${compact ? "px-3 py-2 text-xs" : "px-4 py-3 text-sm"}`} data-testid="promo-banner">
      <Megaphone className={`${compact ? "h-3.5 w-3.5" : "h-4 w-4"} mt-0.5 shrink-0 text-amber-300`} />
      <span>
        🎉 <span className="font-semibold">Oferta especial:</span> {p.description || promoLabel(p)}
        {p.ends_at ? ` até ${fmtDate(p.ends_at)}` : ""}.
        {p.code && <> Use o código <span className="rounded bg-amber-300/20 px-1.5 py-0.5 font-mono-flow font-bold text-amber-200" data-testid="promo-banner-code">{p.code}</span></>}
      </span>
    </div>
  );
}
